module.exports = __webpack_public_path__ + "static/media/loginLogo.5338f59c.svg";